import React, { useRef } from "react";

import imgFlagRu from "../../images/icons/flag/ru.svg";
import imgFlagEs from "../../images/icons/flag/es.svg";
import imgFlagGer from "../../images/icons/flag/ger.svg";
import imgFlagIt from "../../images/icons/flag/it.svg";
import imgFlagUsa from "../../images/icons/flag/usa.svg";
import imgArrowUp from "../../images/icons/iconamoon_arrow-up-2-light.svg";
import { useTranslation } from "react-i18next";
import useLanguage from "../../hooks/site/useLanguage";

export default function ChoseLang() {
  const chooseLangRef = useRef(null);
  // const langs = ["English", "Russian", "Italiano", "Deutch", "Espanol"];
  const langs = ["en_US", "ru_RU", "es_ES"];
  // const langs = i18n.languages;

  const [selectLang, setSelectLang] = useLanguage();

  const getSelect = (lang) => (lang === selectLang ? "select" : "");
  const { t } = useTranslation();

  const flagToLang = {
    ru_RU: imgFlagRu,
    en_US: imgFlagUsa,
    es_ES: imgFlagEs,
    // de_DE: imgFlagGer,
    // it_IT: imgFlagIt,
    de_DE: imgFlagUsa,
    it_IT: imgFlagUsa,
    fr_FR: imgFlagUsa,
    pt_PT: imgFlagUsa,
  };

  const codeByTitle = {
    ru_RU: "Русский",
    en_US: "English",
    es_ES: "Español",

    de_DE: "English",
    it_IT: "English",
    fr_FR: "English",
    pt_PT: "English",
  };

  const catLangByLang = {
    ru_RU: "Ru",
    en_US: "En",
    es_ES: "Es",

    de_DE: "En",
    it_IT: "En",
    fr_FR: "En",
    pt_PT: "En",
  };

  const changeLang = (lang) => {
    setSelectLang(lang);
  };

  const currentImg = flagToLang[selectLang];

  return (
    <div className="chose-lang" onMouseOver={() => chooseLangRef.current.classList.remove("close")}>
      <span className="lang-item main select">
        <img src={currentImg} alt="flag" />
        <span>
          {catLangByLang[selectLang]}
          <img src={imgArrowUp} alt="" className="arrow" />
        </span>
      </span>
      <ul ref={chooseLangRef}>
        {langs.map((el, indx) => (
          <li
            key={indx}
            onClick={() => {
              changeLang(el);
              chooseLangRef.current.classList.add("close");
            }}
            className={`lang-item ${getSelect(el)}`}
          >
            <img src={flagToLang[el]} alt="flag" />
            <span>{t(codeByTitle[el])}</span>
          </li>
        ))}
      </ul>
      <div className="chose-lang__plug" />
    </div>
  );
}
